import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-gel',
  templateUrl: './icon-gel.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconGelComponent {}
